<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:ชื่องบประมาณ  -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label>ชื่องบประมาณ :</label>

                <input
                  id="buBudgetName"
                  name="buBudgetName"
                  v-model="buBudgetName"
                  type="text"
                  maxlength="450"
                  class="form-control"
                />
                <span class="form-text"></span>
              </div>
            </div>
            <!-- End:แบรนด์สินค้า  -->
            <!-- Begin:ประเภทงบประมาณ select2 -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label>ประเภทงบประมาณ :</label>
                <span class="form-control-plaintext">{{buBudgetType}}</span>
              </div>
            </div>
            <!-- End:ประเภทงบประมาณ select2 -->
            <!-- Begin:งบประมาณ input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">งบประมาณ :</label>
                <currency-input
                  class="form-control"
                  v-model="buBudget"
                  id="buBudget"
                  name="buBudget"
                  v-currency="{locale, currency}"
                  auto-decimal-mode:true
                  placeholder="งบประมาณ"
                />
              </div>
            </div>
            <!-- End:งบประมาณ input -->

            <!-- Begin:ใช้ไป input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ใช้ไป :</label>
                <!-- <currency-input
                  class="form-control"
                  v-model="buUsed"
                  v-currency="{locale, currency}"
                  placeholder="ใช้ไป"
                />-->
                <span class="form-control-plaintext">{{buUsed| currency('฿')}}</span>
              </div>
            </div>
            <!-- End:ใช้ไป input -->

            <!-- Begin:คงเหลือ input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">คงเหลือ :</label>
                <span class="form-control-plaintext">{{ BuBalanceCal | currency('฿')}}</span>
              </div>
            </div>
            <!-- End:คงเหลือ input -->

            <!-- Begin:ปี input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ปี :</label>
                <span class="form-control-plaintext">{{buYear}}</span>
              </div>
            </div>
            <!-- End:ปี input -->
            <!-- Begin: status checkbox -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="buStatus"
                      name="buStatus"
                      v-model="buStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <!-- End: status checkbox -->
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueCurrencyInput from "vue-currency-input";
import Vue2Filters from "vue2-filters";

Vue.use(VueCurrencyInput);
Vue.use(Vue2Filters);

export default {
  data() {
    return {
      locale: "th",
      currency: "THB",
      buBudgetName: null,
      buProductBrand: null,
      buProductBrandId: null,
      buBudgetType: null,
      buBudget: null,
      buUsed: null,
      buBalance: null,
      buYear: null,
      buStatus: null
    };
  },
  computed: {
    BuBalanceCal() {
      this.buBalance =
        this.buUsed != null ? this.buBudget - this.buUsed : this.buBudget;
      return this.buBalance;
    }
  },
  methods: {
    formSubmit: function(e) {
      let self = this;
      let router = this.$router;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      axios
        .put("/Api/BudgetBrand", {
          BudgetBrandId: self.$route.params.id,
          BudgetName: self.buBudgetName,
          BudgetType: self.buBudgetType,
          Year: self.buYear,
          Budget: self.buBudget,
          UsedAmout: self.buUsed,
          Balance: self.buBalance,
          InActiveStatus: !self.buStatus
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
    });

    $(this.$refs.form).validate({
      rules: {
        buBudgetName: "required",
        buBudget: "required"
      },
      messages: {
        buBudgetName: "กรุณาระบุชื่องบประมาณ",
        buBudget: "กรุณาระบุงบประมาณ"
      }
    });
    $(this.$refs.form).validate().settings.ignore = ":hidden";

    axios
      .get("/Api/BudgetBrand/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.buBudgetName = response.data.budgetName;
          self.buProductBrandId = response.data.productBrandId;
          self.buBudgetType = response.data.budgetTypeDesc;
          self.buYear = response.data.year;
          self.buBudget = response.data.budget;
          response.data.usedAmout != null
            ? (self.buUsed = response.data.usedAmout)
            : (self.buUsed = 0);
          self.buBalance = response.data.balance;
          self.buStatus = !response.data.inActiveStatus;
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  }
};
</script>


// WEBPACK FOOTER //
// App/Components/Master/Brand/BrandUpdate.vue